<template>
  <a-modal
    :title="title"
    :visible="open"
    :maskClosable="false"
    :keyboard="false"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-card title="剧集导入" style="width: 100%">
        <a-upload-dragger
          name="file"
          accept=".mp4"
          :multiple="true"
          :show-upload-list="false"
          list-type="picture"
          :customRequest="handleChange"
          @change="changeFile"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（导入的文件名请以集数命名，支持：1.mp4、第1集.mp4、第一集.mp4）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadVideoing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
              <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
              {{ item.name }}
              <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" ></a-progress>

            </div>
            <a-icon type="delete" @click.stop="clickDelete(index,1)" />
            <!--            <a-icon type="delete" @click.stop="clickDelete(index,1)" v-if="item.percent == 100" />-->
          </div>
          <!--          <div style="width: 100%;display: flex;justify-content: space-between">-->
          <!--            <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" ></a-progress>-->
          <!--            <a-icon type="delete" @click.stop="clickDelete(index,1)" /></div>-->
        </div>
      </a-card>
      <a-card title="中文简体字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt"
          :multiple="true"
          :show-upload-list="false"
          list-type="picture"
          :customRequest="handleChangeSubtitleZh"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileZhList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadZhing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileZhList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,2)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
        </div>
      </a-card>

      <a-card title="英文字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeEn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileEnList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadEning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileEnList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,3)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="阿拉伯字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeAb"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileAbList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadAbing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileAbList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,4)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="中文繁体字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeTc"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileTcList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadTcing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileTcList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,5)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="韩语字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeKo"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileKoList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadKoing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileKoList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,6)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="越南字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeVi"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileViList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadViing"
                :style="{ margin: '0 32px' }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>
        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileViList" :key="index">
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,7)" v-if="item.percent == 100" />
          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
        </div>
      </a-card>

      <a-card title="法语字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeFr"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileFrList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadFring"
                :style="{ margin: '0 32px' }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>
        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileFrList" :key="index">
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,8)" v-if="item.percent == 100" />
          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
        </div>
      </a-card>

      <a-card title="日语字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeJp"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileJpList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadJping"
                :style="{ margin: '0 32px' }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>
        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileJpList" :key="index">
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,9)" v-if="item.percent == 100" />
          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
        </div>
      </a-card>

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-spin>
  </a-modal>
</template>

<script>

import { importData } from '@/api/video/gather'
import UploadFileToVOD from '@/api/vod'

import UploadFileToVODFile from '@/api/UploadFileToVOD'
import axios from 'axios'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
import { uploadObject, uploadOss, ensureHttpsUrl } from '@/api/tool/oss'
import { getSTSToken } from '@/api/tool/common'
import COS from 'cos-js-sdk-v5'
export default {
  name: 'ImportExcel',
  props: {
  },
  components: {
  },
  data () {
    return {
      title: '导入',
      open: false,
      uploadStatus: '',
      previewImage: '',
      fileList: [],
      fileZhList: [],
      fileEnList: [],
      fileAbList: [],
      fileTcList: [],
      fileKoList: [],
      fileViList: [],
      fileFrList: [],
      fileJpList: [],
      // 是否禁用上传
      uploading: false,
      previewVisible: false,
      updateSupport: 0,
      id: ''
    }
  },

  filters: {
  },
  created () {
  },
  computed: {
    computedUploadVideoing() {
      if (this.fileList.length > 0) {
        return this.fileList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadZhing() {
      if (this.fileZhList.length > 0) {
        return this.fileZhList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadEning() {
      if (this.fileEnList.length > 0) {
        return this.fileEnList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadAbing() {
      return this.getUploadingCount(this.fileAbList)
    },
    computedUploadTcing() {
      return this.getUploadingCount(this.fileTcList)
    },
    computedUploadKoing() {
      return this.getUploadingCount(this.fileKoList)
    },
    computedUploadViing() {
      return this.getUploadingCount(this.fileViList)
    },
    computedUploadFring() {
      return this.getUploadingCount(this.fileFrList)
    },
    computedUploadJping() {
      return this.getUploadingCount(this.fileJpList)
    }
  },
  watch: {
  },
  methods: {
    getUploadingCount(list) {
      if (list.length > 0) {
        return list.filter(i => i.percent != 100 || i.url === '').length
      }
      return 0
    },
    getSerialNumber(name) {
      const serial = this.parseEpisodeSerial(name)
      return serial == null ? null : serial
    },
    parseEpisodeSerial(name) {
      if (!name) {
        return null
      }
      const baseName = name.replace(/\.[^.]+$/, '').trim()
      if (!baseName) {
        return null
      }
      if (baseName.includes('-')) {
        const parts = baseName.split('-')
        const serial = this.parseEpisodeToken(parts[parts.length - 1])
        if (serial != null) {
          return serial
        }
      }
      return this.parseEpisodeToken(baseName)
    },
    parseEpisodeToken(text) {
      if (!text) {
        return null
      }
      const value = String(text).trim()
      if (/^\d+$/.test(value)) {
        return parseInt(value, 10)
      }
      const digitMatch = value.match(/^第(\d+)集$/)
      if (digitMatch) {
        return parseInt(digitMatch[1], 10)
      }
      const cnMatch = value.match(/^第([一二三四五六七八九十百千零两]+)集$/)
      if (cnMatch) {
        return this.chineseToNumber(cnMatch[1])
      }
      return null
    },
    chineseToNumber(cn) {
      if (!cn) {
        return null
      }
      const map = {
        零: 0, 一: 1, 二: 2, 两: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9
      }
      let result = 0
      let current = 0
      for (let i = 0; i < cn.length; i++) {
        const c = cn.charAt(i)
        if (c === '十') {
          if (current === 0) {
            current = 1
          }
          result += current * 10
          current = 0
          continue
        }
        if (c === '百') {
          if (current === 0) {
            current = 1
          }
          result += current * 100
          current = 0
          continue
        }
        if (c === '千') {
          if (current === 0) {
            current = 1
          }
          result += current * 1000
          current = 0
          continue
        }
        if (map[c] == null) {
          return null
        }
        current = map[c]
      }
      result += current
      return result > 0 ? result : null
    },
    validateSerialNumberFiles(fileList, title) {
      for (const file of fileList) {
        const serial = this.getSerialNumber(file.name)
        if (serial == null || serial <= 0) {
          this.$message.error(`${title}文件名无法识别集数：${file.name}，请使用 1.mp4、第1集.mp4 或 第一集.mp4`)
          return false
        }
      }
      return true
    },
    hasPendingSubtitleFiles() {
      return [
        this.fileZhList,
        this.fileEnList,
        this.fileAbList,
        this.fileTcList,
        this.fileKoList,
        this.fileViList,
        this.fileFrList,
        this.fileJpList
      ].some(list => list.length > 0)
    },
    clearSubtitleLists() {
      this.fileZhList = []
      this.fileEnList = []
      this.fileAbList = []
      this.fileTcList = []
      this.fileKoList = []
      this.fileViList = []
      this.fileFrList = []
      this.fileJpList = []
    },
    clickDelete(index, num) {
      const that = this
      this.$confirm({
        content: '是否确认删除呢?',
        centered: true,
        onOk() {
          if (num == 1) {
            that.fileList.splice(index, 1)
          }
          if (num == 2) {
            that.fileZhList.splice(index, 1)
          }
          if (num == 3) {
            that.fileEnList.splice(index, 1)
          }
          if (num == 4) {
            that.fileAbList.splice(index, 1)
          }
          if (num == 5) {
            that.fileTcList.splice(index, 1)
          }
          if (num == 6) {
            that.fileKoList.splice(index, 1)
          }
          if (num == 7) {
            that.fileViList.splice(index, 1)
          }
          if (num == 8) {
            that.fileFrList.splice(index, 1)
          }
          if (num == 9) {
            that.fileJpList.splice(index, 1)
          }
        },
        onCancel() {
          // that.open = false
          // that.fileList = [];
          // that.fileEnList = [];
          // that.fileZhList = [];
        }
      })
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },

    changeFile(info) {
      // console.log('11111111111111111111111')
      // console.log(info)
      // this.fileList.push({
      //   uid:info.file.uid,
      //   name:info.file.name,
      //   status: 'done',
      //   url:'',
      //   percent:0
      // })
    },
    handleChange(info) {
      this.fileList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url: '',
        percent: 0
      })
      const that = this
      // that.form.videoUrl = ""
      const findIndex = that.fileList.findIndex(i => i.uid == info.file.uid)
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          if (findIndex != -1) {
            that.$set(that.fileList[findIndex], 'percent', 100)
            that.fileList[findIndex].url = fileName[0]
            that.$set(that.fileList[findIndex], 'url', fileName[0])
          }
        },
        vProgress: function (val) {
          if (findIndex != -1) {
            that.fileList[findIndex].percent = val * 100
            that.$set(that.fileList[findIndex], 'percent', val * 100)
          }
        },
        fileId: function (val) {
          if (findIndex != -1) {
            that.fileList[findIndex].fileId = val
            that.$set(that.fileList[findIndex], 'fileId', val)
          }
        }
      })
    },

    async handleChangeSubtitleZh(info) {
      await this.uploadToCos(info, this.fileZhList, 'subtitle/zh', 'fileZhList')
    },

    // 通用的 COS 直传方法
    async uploadToCos(info, fileList, prefix, listName) {
      fileList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })
      const that = this
      const findIndex = fileList.findIndex(i => i.uid == info.file.uid)

      try {
        // 1. 生成文件路径
        const filePath = uploadOss(info.file.name, prefix)
        console.log(`========== 开始上传流程 (${prefix}) ==========`)
        console.log('文件路径:', filePath)

        // 2. 使用 getAuthorization 回调方式，动态获取临时凭证
        const cos = new COS({
          getAuthorization: async function(options, callback) {
            try {
              const stsToken = await getSTSToken()
              if (!stsToken || !stsToken.data) {
                callback('获取COS凭证失败')
                return
              }

              const startTime = Math.floor(Date.now() / 1000)
              const expiredTime = startTime + 1800

              callback({
                TmpSecretId: stsToken.data.accessKeyId,
                TmpSecretKey: stsToken.data.accessKeySecret,
                XCosSecurityToken: stsToken.data.securityToken,
                ExpiredTime: expiredTime,
                StartTime: startTime
              })
            } catch (error) {
              callback(error.message || '获取COS凭证失败')
            }
          },
          Protocol: 'https:',
          Timeout: 60000,
          UseAccelerate: false,
          CorrectClockSkew: true
        })

        // 3. 获取 bucket 和 region 信息
        const stsToken = await getSTSToken()
        if (!stsToken || !stsToken.data) {
          throw new Error('获取COS凭证失败')
        }

        const bucket = stsToken.data.bucket
        const region = stsToken.data.region

        // 4. 判断文件大小，选择上传方式
        const fileSize = info.file.size
        const isLargeFile = fileSize > 5 * 1024 * 1024 // 5MB

        let uploadResult
        if (isLargeFile) {
          uploadResult = await cos.uploadFile({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            SliceSize: 1024 * 1024 * 5,
            ContentType: info.file.type || 'application/octet-stream',
            Headers: {},
            onProgress: function(progressData) {
              if (findIndex != -1) {
                const percent = Math.round(progressData.percent * 100)
                that.$set(fileList[findIndex], 'percent', percent)
              }
            }
          })
        } else {
          uploadResult = await cos.putObject({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            ContentType: info.file.type || 'application/octet-stream',
            Headers: {},
            onProgress: function(progressData) {
              if (findIndex != -1) {
                let percent = 0
                if (progressData.percent !== undefined) {
                  percent = Math.round(progressData.percent * 100)
                } else if (progressData.loaded && progressData.total) {
                  percent = Math.round((progressData.loaded / progressData.total) * 100)
                }
                that.$set(fileList[findIndex], 'percent', percent)
              }
            }
          })
        }

        // 5. 检查上传结果并构建 URL
        if (uploadResult && (uploadResult.statusCode === 200 || uploadResult.ETag || uploadResult.Location)) {
          let url = ''
          if (stsToken.data.staticUrl) {
            url = stsToken.data.staticUrl + (stsToken.data.staticUrl.endsWith('/') ? '' : '/') + filePath
          } else if (uploadResult.Location) {
            url = uploadResult.Location
          } else {
            url = `https://${bucket}.cos.${region}.myqcloud.com/${filePath}`
          }
          // 确保 URL 包含 https:// 前缀
          url = ensureHttpsUrl(url)

          if (findIndex != -1) {
            that.$set(fileList[findIndex], 'percent', 100)
            that.$set(fileList[findIndex], 'status', 'done')
            that.$set(fileList[findIndex], 'url', url)
          }
        } else {
          throw new Error('上传失败，返回结果异常')
        }
      } catch (error) {
        console.error(`========== 上传失败 (${prefix}) ==========`)
        console.error('错误详情:', error)

        let errorMessage = '上传失败：'
        if (error.message) {
          errorMessage += error.message
        } else {
          errorMessage += '未知错误'
        }

        if (findIndex != -1) {
          that.$set(fileList[findIndex], 'status', 'error')
          that.$set(fileList[findIndex], 'percent', 0)
          that.$message.error(errorMessage)
        }
      }
    },

    async handleChangeEn(info) {
      await this.uploadToCos(info, this.fileEnList, 'subtitle/en', 'fileEnList')
    },

    async handleChangeAb(info) {
      await this.uploadToCos(info, this.fileAbList, 'subtitle/ab', 'fileAbList')
    },

    async handleChangeTc(info) {
      await this.uploadToCos(info, this.fileTcList, 'subtitle/tc', 'fileTcList')
    },

    async handleChangeKo(info) {
      await this.uploadToCos(info, this.fileKoList, 'subtitle/ko', 'fileKoList')
    },

    async handleChangeVi(info) {
      await this.uploadToCos(info, this.fileViList, 'subtitle/vi', 'fileViList')
    },

    async handleChangeFr(info) {
      await this.uploadToCos(info, this.fileFrList, 'subtitle/fr', 'fileFrList')
    },

    async handleChangeJp(info) {
      await this.uploadToCos(info, this.fileJpList, 'subtitle/jp', 'fileJpList')
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      const that = this
      if (this.fileList.length > 0 || this.hasPendingSubtitleFiles()) {
        this.$confirm({
          content: '您上传的短剧/字幕文件尚未保存是否关闭',
          centered: true,
          onOk() {
            that.open = false
            that.fileList = []
            that.clearSubtitleLists()
          },
          onCancel() {
            // that.open = false
            // that.fileList = [];
            // that.fileEnList = [];
            // that.fileZhList = [];
          }
        })
      } else {
        this.open = false
        this.fileList = []
        this.clearSubtitleLists()
      }

      // // 关闭后刷新列表
      // this.$emit('ok')
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('/video/video-gather/importTemplate', {
        ...this.queryParams
      }, `gather_template_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.id = e
      this.open = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    /** 导入excel */
    importExcelHandleChange () {
      if (this.fileList.length > 0) {
        if (this.computedUploadVideoing != 0) {
          this.$message.error('剧集文件还未上传完毕,请耐心等待')
          return
        }
      }

      const subtitleChecks = [
        { list: this.fileZhList, uploading: this.computedUploadZhing, title: '中文简体字幕' },
        { list: this.fileEnList, uploading: this.computedUploadEning, title: '英文字幕' },
        { list: this.fileAbList, uploading: this.computedUploadAbing, title: '阿拉伯字幕' },
        { list: this.fileTcList, uploading: this.computedUploadTcing, title: '中文繁体字幕' },
        { list: this.fileKoList, uploading: this.computedUploadKoing, title: '韩语字幕' },
        { list: this.fileViList, uploading: this.computedUploadViing, title: '越南字幕' },
        { list: this.fileFrList, uploading: this.computedUploadFring, title: '法语字幕' },
        { list: this.fileJpList, uploading: this.computedUploadJping, title: '日语字幕' }
      ]
      for (const item of subtitleChecks) {
        if (item.list.length > 0 && item.uploading !== 0) {
          this.$message.error(`${item.title}文件还未上传完毕,请耐心等待`)
          return
        }
      }

      this.uploading = true
      if (!this.validateSerialNumberFiles(this.fileList, '剧集')) {
        this.uploading = false
        return
      }
      const subtitleFileGroups = [
        { list: this.fileZhList, title: '中文简体字幕' },
        { list: this.fileEnList, title: '英文字幕' },
        { list: this.fileAbList, title: '阿拉伯字幕' },
        { list: this.fileTcList, title: '中文繁体字幕' },
        { list: this.fileKoList, title: '韩语字幕' },
        { list: this.fileViList, title: '越南字幕' },
        { list: this.fileFrList, title: '法语字幕' },
        { list: this.fileJpList, title: '日语字幕' }
      ]
      for (const group of subtitleFileGroups) {
        if (!this.validateSerialNumberFiles(group.list, group.title)) {
          this.uploading = false
          return
        }
      }

      const mapSubtitleList = (list, field) => list.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        fileName: i.name,
        [field]: i.url,
        videoId: this.id
      }))
      const arrList = this.fileList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        fileName: i.name,
        videoUrl: i.url,
        fileId: i.fileId,
        videoId: this.id
      }))
      const newArrData = {
        arrList,
        zhList: mapSubtitleList(this.fileZhList, 'subtitle'),
        enList: mapSubtitleList(this.fileEnList, 'subtitleEn'),
        abList: mapSubtitleList(this.fileAbList, 'subtitleAb'),
        tcList: mapSubtitleList(this.fileTcList, 'subtitleTc'),
        koList: mapSubtitleList(this.fileKoList, 'subtitleKo'),
        viList: mapSubtitleList(this.fileViList, 'subtitleVi'),
        frList: mapSubtitleList(this.fileFrList, 'subtitleFr'),
        jpList: mapSubtitleList(this.fileJpList, 'subtitleJp')
      }
      importData(newArrData).then(response => {
        if (response.code == 1 || response.code == 20001) {
          this.fileList = []
          this.clearSubtitleLists()
          this.$message.success(response.message)
          this.open = false
          this.$emit('ok')
        } else {
          this.$message.error(response.message)
        }
      }).finally(() => {
        this.uploading = false
        this.$emit('ok')
      })
    },
    handleCheckedUpdateSupport () {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    },
    handleRemoveZh () {
      this.fileZhList = []
      this.uploading = false
    },
    handleRemoveEn () {
      this.fileEnList = []
      this.fileList = []
      this.uploading = false
    },
    handleRemoveAb () {
      this.fileAbList = []
      this.uploading = false
    },
    handleRemoveTc () {
      this.fileTcList = []
      this.uploading = false
    },
    handleRemoveKo () {
      this.fileKoList = []
      this.uploading = false
    },
    handleRemoveVi () {
      this.fileViList = []
      this.uploading = false
    },
    handleRemoveFr () {
      this.fileFrList = []
      this.uploading = false
    },
    handleRemoveJp () {
      this.fileJpList = []
      this.uploading = false
    }
  }
}
</script>
